import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./contact.css";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  company: "",
  website: "",
  telegram: "",
  twitter: "",
  cmcLink: "",
  message: "",
};

const Contact = () => {
  const [form, setForm] = useState(initialState);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.firstName) return;
    setSubmitting(true);

   const payload = {
  firstname: form.firstName,   // ✅ match EmailJS {{firstname}}
  lastname: form.lastName,     // ✅ match EmailJS {{lastname}}
  email: form.email,
  company: form.company,
  website: form.website,
  telegram: form.telegram,
  twitter: form.twitter,
  coinlink: form.cmcLink,      // ✅ match EmailJS {{coinlink}}
  message: form.message,
  time: new Date().toLocaleString(), // ✅ match EmailJS {{time}}
};

    try {
      await emailjs.send(
        "service_4xe5zyv",         // ✅ your service ID
        "template_sh6bkym",        // ✅ your template ID
        payload,
        "SZyIQkXjx6otof1ud"        // ✅ your public key
      );
      setSubmitted(true);
      setForm(initialState);
    } catch (err) {
      console.error("EmailJS Error:", err);
      alert("Failed to send message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="contact-heading">Contact Us</h2>
          <p className="contact-subtitle">
            Tell us about your project. We usually respond within 24 hours.
          </p>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-field">
              <label className="form-label">
                First name<span className="required">*</span>
              </label>
              <input
                className="form-input"
                type="text"
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-field">
              <label className="form-label">
                Last name<span className="required">*</span>
              </label>
              <input
                className="form-input"
                type="text"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-field full">
              <label className="form-label">
                Email<span className="required">*</span>
              </label>
              <input
                className="form-input"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-field">
              <label className="form-label">Company name</label>
              <input
                className="form-input"
                type="text"
                name="company"
                value={form.company}
                onChange={handleChange}
              />
            </div>

            <div className="form-field">
              <label className="form-label">Website</label>
              <input
                className="form-input"
                type="url"
                name="website"
                value={form.website}
                onChange={handleChange}
              />
            </div>

            <div className="form-field">
              <label className="form-label">Telegram</label>
              <input
                className="form-input"
                type="text"
                name="telegram"
                value={form.telegram}
                onChange={handleChange}
                placeholder="@username"
              />
            </div>

            <div className="form-field">
              <label className="form-label">X / Twitter Handle @</label>
              <input
                className="form-input"
                type="text"
                name="twitter"
                value={form.twitter}
                onChange={handleChange}
                placeholder="@yourhandle"
              />
            </div>

            <div className="form-field">
              <label className="form-label">CMC / CoinGecko Link</label>
              <input
                className="form-input"
                type="url"
                name="cmcLink"
                value={form.cmcLink}
                onChange={handleChange}
                placeholder="https://"
              />
            </div>

            <div className="form-field full">
              <label className="form-label">Message</label>
              <textarea
                className="form-textarea"
                name="message"
                rows="6"
                value={form.message}
                onChange={handleChange}
                placeholder="Your message"
              />
            </div>
          </div>

          <div className="form-actions">
            <button className="btn-submit" type="submit" disabled={submitting}>
              {submitting ? "Sending..." : "Send Message"}
            </button>
            {submitted && (
              <span className="submit-success">
                ✅ Thanks! We'll get back to you shortly.
              </span>
            )}
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
